"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=function(r,g,b){return"#"+(16777216+(r<<16)+(g<<8)+b).toString(16).slice(1)};


//////////////////
// WEBPACK FOOTER
// ./node_modules/form-components/lib/__utils/helpers/rgbToHex.js
// module id = 737
// module chunks = 0